<form class="company-list">
  <mat-form-field>
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let company of filteredCompanies | async" [value]="company">
        {{company?.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>

<!-- <form class="company-list">
  <mat-form-field>
    <mat-select [formControl]="myControl">
      <mat-option *ngFor="let company of companies" [value]="company">
         {{company?.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form> -->